"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonStatus = exports.SchoolType = exports.LessonType = exports.Location = exports.Weekday = void 0;
// ---------- Enums ----------
var Weekday;
(function (Weekday) {
    Weekday["Mon"] = "pon";
    Weekday["Tue"] = "wt";
    Weekday["Wed"] = "\u015Br";
    Weekday["Thu"] = "czw";
    Weekday["Fri"] = "pt";
    Weekday["Sat"] = "sob";
    Weekday["Sun"] = "nd";
})(Weekday || (exports.Weekday = Weekday = {}));
var Location;
(function (Location) {
    Location["Lanciego"] = "Lanciego";
    Location["Cynamonowa"] = "Cynamonowa";
    Location["Online"] = "online";
})(Location || (exports.Location = Location = {}));
var LessonType;
(function (LessonType) {
    LessonType["KI"] = "Korepetycje indywidualne";
    LessonType["KG"] = "Korepetycje grupowe";
    LessonType["K8"] = "Kurs \u00F3smoklasisty";
    LessonType["KM"] = "Kurs maturalny";
    LessonType["WS"] = "Warsztaty";
})(LessonType || (exports.LessonType = LessonType = {}));
var SchoolType;
(function (SchoolType) {
    SchoolType["SP"] = "Szko\u0142a podstawowa";
    SchoolType["LIC"] = "Liceum";
    SchoolType["TECH"] = "Technikum";
})(SchoolType || (exports.SchoolType = SchoolType = {}));
var LessonStatus;
(function (LessonStatus) {
    LessonStatus["Regular"] = "regular";
    LessonStatus["Cancelled"] = "cancelled";
    LessonStatus["Rescheduled"] = "rescheduled";
    LessonStatus["Extra"] = "extra";
})(LessonStatus || (exports.LessonStatus = LessonStatus = {}));
